<template>
   <account :params="params.account" @setTabEvent="setActiveTab">
      <template #before>
          <a-select
              class="account__select-nav"
              label=""
              name="categories"
              :options="params.account.menu"
              display="title"
              value="url"
              hideSelected
              v-model="currentPage"
              dropdownClasses="account__select-nav-dropdown"
          >
              <template #item="item">
                  <div class="flex v-center account__select-nav-item">
                      <a :href="item.url">{{ item.title }}</a>
                  </div>
              </template>
          </a-select>
      </template>
      <a-tab v-for="(tab, i) in paramsTabs" :key="i" :name="i" :show="i==defShowIndex" v-model="currentTabIndex">
          <div class="ChatPageContainer" :class="{closed: !contactsListOpened}">
              <div class="ChatPageContainer__in">
                  <div class="ChatPageContainer__left" v-if="paramsTabs[i].rooms.ITEMS">
                      <div v-for="room in paramsTabs[i].rooms.ITEMS">
                          <UserContact
                                  :user="{name: room.title, avatar: room.picture}"
                                  :info="room"
                                  @click.prevent="setChat(room)"
                                  :stats="{time: room.dataSet, active:room.current, status: 'delivered', date: room.dataSet}"
                          />
                          <!--status:sent|read|delivered&ndash-->
                      </div>
                  </div>
                  <div class="ChatPageContainer__right">
                      <ChatWindow
                              @addMessage="addMessage"
                              @showMore="showMore"
                              :langMessage="params.messages"
                              :params="paramsTabs[i].currentChat"
                              ref="chatWindow"/>
                  </div>
            </div>
        </div>
      </a-tab>
      <template #aside>

          <account-card v-bind="params.account.cardInfo" v-if="params.account.cardInfo">
            <template #actions>
              <div class="ActionCard__button" v-if="isCompany">
                <ABtn :label="params.account.cardInfo.newTask.text"
                  color="#fff"
                  bg="var(&#45;&#45;c-secondary-200)"
                  :href="params.account.cardInfo.newTask.link"
                />
              </div>
            </template>
          </account-card>
          <aside-nav :items="params.account.menu"/>
          <ProgressCard v-if="params.account.progress" :data="params.account.progress"/>
          <UserDescription
                  v-if="params.account.user"
                  :description="params.account.user.description"
                  :social="params.account.user.social"
          />
          <IntroCard/>
      </template>
    </account>
</template>

<script>

import {ref, computed, onMounted, onUpdated, nextTick} from 'vue'
import Account from './Account.vue'
import AccountCard from '../cards/AccountCard.vue'
import AsideNav from '../AsideNav.vue'
import {
    ATab,
    ABtn,
    ABadge,
    AField,
    AInput,
    ACheckbox,
    ASelect,
    AChip,
    ADatePicker,
    useAProgressBar,

    AVideo,
} from '../ui'
import UserFiles from '../cards/UserFiles.vue'
import {required, isEmail, isPhone, fileRules} from '../../libs/Validators'
import {getType} from '../ui/utils/helpers'
import {saveAccountNPO, send} from '../../services/api'
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from "swiper";

import 'swiper/css';
import 'swiper/css/navigation';
import ProgressCard from "../cards/ProgressCard";
import UserDescription from "../cards/UserDescription";
import TagListSection from "./TagListSection";
import IntroCard from "../cards/IntroCard";
import ProjectListSection from "./ProjectListSection";
import ActionCard from "../cards/ActionCard";
import UserContact from "../chat/UserContact.vue";
import ChatWindow from "../chat/ChatWindow.vue";
import {useStore} from "vuex";
import TouchEvent from "../../libs/TouchEvent";
import loginForm from "../forms/auth/LoginForm.vue";

export default {
    name: 'AccountChat',
    components: {
        ChatWindow,
        UserContact,
        ActionCard,
        ProjectListSection,
        IntroCard,
        TagListSection,
        UserDescription,
        ProgressCard,
        Account,
        AccountCard,
        AsideNav,
        ATab,
        ABtn,
        ABadge,
        UserFiles,
        AField,
        AInput,
        ACheckbox,
        ASelect,
        AChip,
        ADatePicker,
        required,
        isEmail,
        isPhone,
        fileRules,
        Swiper,
        SwiperSlide,
        Navigation,
        AVideo
    },
    props: ['params'],
    setup: (props, ctx) => {
        const defShowIndex = ref(0);
        const currentTabIndex = ref(0);
        const progress = useAProgressBar();
        const isCompany = computed(() => {
            return props.params.account.cardInfo.isCompany === true
        });
        const currentPage = ref(props.params.account.menu.filter(row => row.current)[0]);
        const paramsTabs = ref(props.params.account.tabs);
        const $store = useStore();
        const loading = ref(false);
        const chatWindow = ref(null);
        const contactsListOpened = ref(true);
        const swipeDirection = ref(null)
        if(props.params.account.tabs[defShowIndex.value]?.disabled) {
            for(let index in props.params.account.tabs) {
                if(props.params.account.tabs[defShowIndex.value]?.disabled) {
                    defShowIndex.value = index;
                    currentTabIndex.value = index;
                }
            }
        }
        for(let index in props.params.account.tabs) {
            if(props.params.account.tabs[index]?.active) {
                defShowIndex.value = parseInt(index);
                currentTabIndex.value = parseInt(index);
            }
        }

        const setActiveTab = (e) => {
          if(e.index) {
            console.log(e);
            currentTabIndex.value = parseInt(e.index);
            if(paramsTabs.value[currentTabIndex.value]?.currentChat?.link) {
              history.pushState(null, null, paramsTabs.value[currentTabIndex.value]?.currentChat?.link);
            }
            console.log(props.params.account.tabs[currentTabIndex.value]);
          }
        }
        const setChat = async (e) => {
            history.pushState(null, null, e.link);
            progress.show();
            await send(e.link, {method: "GET"}, {api: 'y'}).then((response) => {
                console.log(chatWindow.value[0].scrollBottom());
                paramsTabs.value = response[props.params.responseKey].account.tabs;
                progress.hide();
            })
        };
        const showMore = async (params) => {

            if(!loading.value) {
                $store.commit('global/loaderStart');
                loading.value = true;
                const chatScrollElement = document.querySelector('.ChatWindow__in')

                await send(params.page, {method: "GET"}, {}).then((response) => {

                    paramsTabs.value[currentTabIndex.value].currentChat.MESSAGES.PAGEN = response[props.params.responseKey].account.tabs[currentTabIndex.value].currentChat.MESSAGES.PAGEN;
                    paramsTabs.value[currentTabIndex.value].currentChat.MESSAGES.ITEMS =  [
                        ...response[props.params.responseKey].account.tabs[currentTabIndex.value].currentChat.MESSAGES.ITEMS,
                        ...paramsTabs.value[currentTabIndex.value].currentChat.MESSAGES.ITEMS
                    ];
                    loading.value = false;
                    $store.commit('global/loaderStop');
                    if(chatScrollElement) {
                        nextTick(() => {
                            const header = document.querySelector('.header')
                            const el = document.getElementById(params.scrollElementId)
                            const rect = el.getBoundingClientRect()

                            el.scrollIntoView()
                            window.scrollTo(0, window.scrollY - header.clientHeight || 100)
                        })
                    }
                })

            }
        };
        const addMessage = async (e) => {

            let formData = new FormData();
            let curTab = currentTabIndex.value;
            if(curTab==undefined) {
                curTab = defShowIndex.value;
            }
            for(let index in paramsTabs.value[curTab].currentChat.api.addMessage.data) {
                formData.append(index,paramsTabs.value[curTab].currentChat.api.addMessage.data[index]);
            }
            if(e.file||e.text) {
                if(e.file) {
                    formData.append('file',e.file);
                }
                if(e.text) {
                    formData.append('text',e.text);
                }
                progress.show();
                await send(paramsTabs.value[curTab].currentChat.api.addMessage.link, {method: "POST"}, formData).then((response) => {
                     if(response.messageInfo) {
                         //paramsData.value.tabs[currentTab.value].CURRENT_CHAT.MESSAGES.ITEMS.push(response.messageInfo);
                     }
                     chatWindow.value[0].scrollBottom()
                     progress.hide();
                })
            }
        };

        const updateCurentChat = async () =>{
            let curTab = currentTabIndex.value;
            if(curTab==undefined) {
                curTab = defShowIndex.value;
            }
            if(paramsTabs.value[curTab].currentChat.api) {
                let d = JSON.parse(JSON.stringify(paramsTabs.value[curTab].currentChat.api.getNewMessages.data));
                d.lastMessageId = 0;
                if(paramsTabs.value[curTab].currentChat.MESSAGES.ITEMS) {
                    let lastMessage = paramsTabs.value[curTab].currentChat.MESSAGES.ITEMS[paramsTabs.value[curTab].currentChat.MESSAGES.ITEMS.length-1];
                    if(lastMessage!=undefined) {
                        d.lastMessageId = lastMessage.id;
                    }
                } else {
                    paramsTabs.value[curTab].currentChat.MESSAGES.ITEMS = [];
                }
                let formData = new FormData();
                for (let name in d) {
                    formData.append(name,d[name]);
                }
                await send(
                    paramsTabs.value[curTab].currentChat.api.getNewMessages.link,
                    {method: "POST"},
                    formData
                ).then((response) => {
                    if(response.ITEMS.length>0) {
                        console.log(response.ITEMS);
                        paramsTabs.value[curTab].currentChat.MESSAGES.ITEMS =  [
                            ...paramsTabs.value[curTab].currentChat.MESSAGES.ITEMS,
                            ...response.ITEMS,
                        ];
                    }
                    setTimeout(()=>{
                        updateCurentChat();
                    },500);

                })
            } else {
                setTimeout(()=>{
                    updateCurentChat();
                },500);
            }
        }

        onMounted(() => {
            let touchEvent = null;
            const page = document.querySelector('.ChatPageContainer')

            page.addEventListener('touchstart', (event) => {
                touchEvent = new TouchEvent(event);
            });

            page.addEventListener('touchend', handleSwipe);

            function handleSwipe(event) {
                if (!touchEvent) {
                    return;
                }

                touchEvent.setEndEvent(event);

                if (touchEvent.isSwipeRight()) {
                    // Do something
                    contactsListOpened.value = true
                } else if (touchEvent.isSwipeLeft()) {
                    // Do something different
                    contactsListOpened.value = false
                }

                // Reset event for next touch
                touchEvent = null;
            }
            setTimeout(()=>{
                updateCurentChat();
            },500);
        })

        return {
          defShowIndex,
            addMessage,
            showMore,
          required,
            paramsTabs,
          modules: [Navigation],
            setActiveTab,
          currentPage,
            setChat,
          isCompany,
            contactsListOpened,
            currentTabIndex,
            swipeDirection,
            chatWindow,

        }
    },
}
</script>

<style lang="scss" scoped>
$contactsWidth: rem(280);
$contactsWidthTablet: rem(260);
$contactsWidthMobile: 100%;
.account__body-section {
    margin-top: 72px;

    .col:first-child {
        .account__body-section {
            margin-top: 0px;
        }
    }
}

::v-deep(.account-card) {
    .a-avatar__inner {
        width: auto !important;
        height: 130px !important;
        border-radius: 0;

        @include tablet {
            max-height: 80px;
        }
    }

    .account-card__bottom {
        @include tablet {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        @include mobile {
            display: block;
        }
    }
}

::v-deep(.account__body-section) {
    h3 {
        margin-bottom: 0;
    }
}

::v-deep(.account__header) {
    display: none !important;
}

.user-files {
    margin-top: 28px;
}

.user-files__remove-btn {
    font-size: 16px;
    color: var(--c-gray-500);
    cursor: pointer;
    transition: all .3s ease;

    &:hover {
        color: var(--c-gray-400);
    }
}

.account__select-nav {
    display: none;
    @include tablet {
        display: flex;
    }
}

.aside-nav {
    @include tablet {
        display: none;
    }
}

.ChatPageContainer {
  background-color: #fff;
  height: 100%;

  &__in {
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 90vh;
    max-height: 90vh;
    border: 1px solid var(--c-gray-600);
    @include mobile {
      width: 100%;
    }
  }
  &__left {
    width: $contactsWidth;
    flex: 0 1 $contactsWidth;
    border-right: 1px solid var(--c-gray-600);
    margin-left: 0;
    transition: margin-left .5s;
    max-height: 100vh;
    overflow: auto;
    @include tablet {
      width: $contactsWidthTablet;
      flex: 0 1 $contactsWidthTablet;
    }

    @include mobile {
      width: $contactsWidthMobile;
      flex: 1 0 $contactsWidthMobile;
    }

    .closed & {
      margin-left: -$contactsWidth;

      @include tablet {
        margin-left: -$contactsWidthTablet;
      }

      @include mobile {
        margin-left: -$contactsWidthMobile;
      }
    }
  }

  &__right {
    flex: 1;

    max-height: 100vh;
    overflow: visible;

    @include mobile {
      width: 100%;
      flex: 0 1 100%;
    }


    .closed & {

    }
  }
}
</style>

<style lang="scss">
.page__account {
    .tags {
        .a-chip__inner {
            background: #fff;
        }
    }
}

.account__additional-link .label {
    margin-left: 62px;
    @include mobile {
        margin-left: 44px;
    }
}

.account__select-nav-dropdown .a-item {
    padding: 0;

    a {
        color: var(--c-gray-100);
        width: 100%;
        display: flex;
        align-items: center;
        padding: 12px 16px;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>